export default function TextAreaInput(props) {

  return (
    <textarea className="form__fields__input form__fields__textarea" name={props.name} id={props.label} placeholder={props.label} required={props.required} rows="1"></textarea>
  );
}
